@if (billingRunTypesWidgetData && initialized) {
    <mvs-widget [widgetData]="billingRunTypesWidgetData"></mvs-widget>
}
